
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/destinations/hubdb",
      function () {
        return require("private-next-pages/destinations/hubdb.mdx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/destinations/hubdb"])
      });
    }
  